import React, { useMemo } from "react";
import DataTable from "../../../Components/Table";
import { formatAccount } from "../../../../features/ValueFormater";

function PaymentTypeBadge({ value }) {
  if (!value) return <span>-</span>;

  if (value === "Automatically Paid") {
    return <span className="bills-page__history-status is-success">{value}</span>;
  }

  if (value === "Insufficient Funds") {
    return <span className="bills-page__history-status is-warning">{value}</span>;
  }

  return <span>{value}</span>;
}

export default function TransactionHistoryTable({
  error,
  errorMessage,
  isAutomatable = false,
  onRetry,
  onAutoPay,
  transactions = [],
}) {
  const columns = useMemo(() => {
    const baseColumns = [
      {
        header: "Transaction",
        accessor: "Transaction",
      },
      {
        header: "Description",
        accessor: "Description",
      },
      {
        header: "Amount",
        accessor: "Amount",
        cell: ({ row, value }) =>
          formatAccount(value, row?.CurrencyId),
      },
      {
        header: "Payment Date",
        accessor: "PaymentDate",
      },
    ];

    if (isAutomatable) {
      baseColumns.push(
        {
          header: "Payment Type",
          accessor: "PaymentType",
          cell: ({ value }) => <PaymentTypeBadge value={value} />,
        },
        {
          id: "actions",
          header: "",
          align: "right",
          cell: ({ row }) => {
            const canToggleAutoPay =
              row?.Info !== null && row?.Info !== undefined;
            const isEnabled = Boolean(row?.AutoEnabled);

            if (!canToggleAutoPay) {
              return null;
            }

            return (
              <button
                type="button"
                className={`btn bills-page__history-action ${
                  isEnabled ? "is-danger" : "is-primary"
                }`}
                onClick={(event) => {
                  event.stopPropagation();
                  onAutoPay?.(row);
                }}
              >
                {isEnabled ? "Disable Auto-Pay" : "Enable Auto-Pay"}
              </button>
            );
          },
        },
      );
    }

    return baseColumns;
  }, [isAutomatable, onAutoPay]);

  return (
    <div className="bills-page__history-table-shell card">
      <DataTable
        columns={columns}
        data={transactions}
        error={error}
        errorMessage={errorMessage}
        onRetry={onRetry}
        emptyMessage="No transactions available."
        rowKey="Transaction"
      />
    </div>
  );
}
